import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import { IoMdAddCircle } from "react-icons/io";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import {
  addProduct,
  getCategoryList,
  updateProduct,
  uploadProductImages,
  removeProductImage,
} from "../../../redux/reducers/productSlice";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { useLocation } from "react-router-dom";
import { LuImage, LuPlus, LuTrash2, LuX, LuUpload } from "react-icons/lu";
import Spinner from "../../../components/Spinner";
import ConfirmModal from "../../../components/ConfirmModal";

export default function AddProduct({ type, data }) {
  // const location = useLocation();
  const [show, setShow] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [showRemoveImgModal, setShowRemoveImgModal] = useState(false);
  const [imgToRemove, setImgToRemove] = useState("");
  const handleClose = () => {
    setShow(false);
    setSelectedFiles([]);
    setPreviews([]);
  };
  const handleShow = () => setShow(true);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const totalCurrentImages = (data?.images?.length || 0) + selectedFiles.length;
    
    if (totalCurrentImages + files.length > 5) {
      alert("You can only have up to 5 images per product.");
      return;
    }

    const newFiles = [...selectedFiles, ...files];
    setSelectedFiles(newFiles);

    const newPreviews = files.map(file => URL.createObjectURL(file));
    setPreviews([...previews, ...newPreviews]);
  };

  const removeFile = (index) => {
    const newFiles = [...selectedFiles];
    newFiles.splice(index, 1);
    setSelectedFiles(newFiles);

    const newPreviews = [...previews];
    URL.revokeObjectURL(newPreviews[index]);
    newPreviews.splice(index, 1);
    setPreviews(newPreviews);
  };

  const handleRemoveExistingImage = (imageUrl) => {
    setImgToRemove(imageUrl);
    setShowRemoveImgModal(true);
  };

  //get product category list
  const dispatch = useDispatch();
  const selectedBusiness = useSelector(
    (state) => state.business.selectedBusiness
  );

  const { loading, categoryList: productcategorydata } = useSelector(
    (state) => state.product
  );

  useEffect(() => {
    if (selectedBusiness?._id) {
      dispatch(getCategoryList(selectedBusiness?._id));
    }
  }, [dispatch, selectedBusiness]);

  //formik initial values
  const initialValues = {
    id: type === "update" && data?._id,
    name: type === "update" ? data?.name : "",
    description: type === "update" ? data?.description : "",
    productCategory: type === "update" ? data?.productCategory?._id : "",
    quantity: type === "update" ? data?.quantity : 0,
    productType: type === "update" ? data?.productType || "item" : "item",
    price: type === "update" ? data?.price : "",
    pricingTiers: type === "update" ? data?.pricingTiers || [] : [],
    business: type === "update" ? data?.business : selectedBusiness?._id,
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Product Name Required"),
    price: Yup.number().typeError("Must be a number").min(0, "Price must be positive").required("Product Price Required"),
    quantity: Yup.number().when("productType", {
      is: "item",
      then: (schema) => schema.required("Quantity Required").min(0, "Quantity must be positive"),
      otherwise: (schema) => schema.notRequired(),
    }),
    productType: Yup.string().required("Product Type Required"),
    productCategory: Yup.string().required("Product Category Required"),
  });
  const onSubmit = (values, { setFieldError }) => {
    // If service, ensure quantity is handled (e.g., set to 0 or null)
    const processedValues = {
      ...values,
      quantity: values.productType === "service" ? 0 : values.quantity,
    };
    if (type === "add") {
      dispatch(addProduct(processedValues)).then((res) => {
        if (res.payload && res.payload._id && selectedFiles.length > 0) {
          dispatch(uploadProductImages({ id: res.payload._id, files: selectedFiles })).then(() => {
            handleClose();
          });
        } else if (res.payload.status !== "error") {
          handleClose();
        }
      });
    } else {
      dispatch(updateProduct(processedValues)).then((res) => {
        if (res.payload && res.payload._id && selectedFiles.length > 0) {
          dispatch(uploadProductImages({ id: res.payload._id, files: selectedFiles })).then(() => {
            handleClose();
          });
        } else if (res.payload.status !== "error") {
          handleClose();
        }
      });
    }
  };
  return (
    <div className="d-inline-block">
      <div onClick={handleShow} style={{ cursor: 'pointer' }}>
        {type === "add" ? (
          <button className="btn btn-primary d-flex align-items-center gap-2">
            <IoMdAddCircle size={20} /> New Product
          </button>
        ) : (
          <div className="action-icon-edit text-primary p-2 rounded-circle bg-light d-flex align-items-center justify-content-center" title="Edit Product">
            <FaRegEdit size={16} />
          </div>
        )}
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        className="premium-modal"
        backdrop="static"
      >
        <Modal.Header className="border-0 pb-0 pt-4 px-4 position-relative">
          <Modal.Title className="fw-bold text-dark fs-4">
            {type === "add" ? "Create New Product" : "Update Product Details"}
          </Modal.Title>
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-3 p-2 bg-light rounded-circle shadow-sm"
            onClick={loading ? null : handleClose}
            disabled={loading}
            aria-label="Close"
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Spinner active={loading}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {(formik) => (
                <Form>
                  <div className="row g-4">
                    <div className="col-md-12 text-start">
                      <label className="invoice-label">Product Name <span className="text-danger">*</span></label>
                      <Field
                        type="text"
                        name="name"
                        className="gbl-input w-100"
                        placeholder="Enter Product Name"
                      />
                      <ErrorMessage name="name" component="div" className="formik_red_txt mt-1 small" />
                    </div>

                    <div className="col-md-12 text-start">
                      <label className="invoice-label">Description</label>
                      <Field
                        as="textarea"
                        name="description"
                        className="gbl-input w-100"
                        rows={3}
                        placeholder="Enter Product Description"
                      />
                    </div>

                    <div className="col-md-6 text-start">
                      <label className="invoice-label">Category <span className="text-danger">*</span></label>
                      <Field name="productCategory">
                        {({ field, form: { setFieldValue } }) => (
                          <ReactSelect
                            options={productcategorydata?.map((e) => ({
                              label: e?.name,
                              value: e?._id,
                            }))}
                            placeholder="Select Category"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            value={productcategorydata?.filter(e => e._id === field.value).map(e => ({ label: e.name, value: e._id }))[0]}
                            isSearchable
                            onChange={(option) => {
                              setFieldValue(field.name, option.value);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="productCategory" component="div" className="formik_red_txt mt-1 small" />
                    </div>

                    <div className="col-md-6 text-start">
                      <label className="invoice-label">Product Type <span className="text-danger">*</span></label>
                      <div className="d-flex gap-3 mt-2">
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="productType"
                            value="item"
                            className="form-check-input"
                            id="typeItem"
                          />
                          <label className="form-check-label" htmlFor="typeItem">Item</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="productType"
                            value="service"
                            className="form-check-input"
                            id="typeService"
                          />
                          <label className="form-check-label" htmlFor="typeService">Service</label>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 text-start">
                      <label className="invoice-label">Quantity {formik.values.productType === 'item' && <span className="text-danger">*</span>}</label>
                      <Field
                        type="number"
                        name="quantity"
                        min="0"
                        className="gbl-input w-100"
                        placeholder="0"
                        disabled={formik.values.productType === 'service'}
                      />
                      {formik.values.productType === 'item' && (
                        <ErrorMessage name="quantity" component="div" className="formik_red_txt mt-1 small" />
                      )}
                    </div>

                    <div className="col-md-6 text-start">
                      <label className="invoice-label">Price <span className="text-danger">*</span></label>
                      <Field
                        type="number"
                        name="price"
                        min="0"
                        step="0.01"
                        className="gbl-input w-100"
                        placeholder="0.00"
                      />
                      <ErrorMessage name="price" component="div" className="formik_red_txt mt-1 small" />
                    </div>

                    {/* Tiered Pricing Section */}
                    <div className="col-12 mt-4 px-2 pb-2 border-bottom">
                      <h6 className="text-uppercase text-muted fw-bold small mb-0">Tiered Pricing (Optional)</h6>
                    </div>
                    
                    <div className="col-12">
                      <FieldArray name="pricingTiers">
                        {({ push, remove }) => (
                          <div className="row g-2">
                            {formik.values.pricingTiers?.map((tier, index) => (
                              <div key={index} className="col-12 d-flex gap-2 align-items-end mb-2">
                                <div style={{ flex: 1 }}>
                                  <label className="extra-small text-muted mb-1">Min Qty</label>
                                  <Field
                                    type="number"
                                    name={`pricingTiers.${index}.minQuantity`}
                                    className="gbl-input w-100"
                                    placeholder="100"
                                  />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <label className="extra-small text-muted mb-1">Price each ($)</label>
                                  <Field
                                    type="number"
                                    name={`pricingTiers.${index}.price`}
                                    className="gbl-input w-100"
                                    placeholder="8.00"
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm mb-1"
                                  onClick={() => remove(index)}
                                >
                                  <LuTrash2 size={16} />
                                </button>
                              </div>
                            ))}
                            <div className="col-12 mt-2">
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2 rounded-pill px-3"
                                onClick={() => push({ minQuantity: '', price: '' })}
                              >
                                <LuPlus size={16} /> Add Price Tier
                              </button>
                            </div>
                          </div>
                        )}
                      </FieldArray>
                    </div>

                    {/* Image Upload Section */}
                    <div className="col-md-12 text-start mt-3">
                      <label className="invoice-label d-block mb-2">Product Images (Up to 5)</label>
                      <div className="d-flex flex-wrap gap-3">
                        {/* Existing Images */}
                        {type === "update" && data?.images?.map((img, idx) => (
                          <div key={`existing-${idx}`} className="position-relative" style={{ width: '80px', height: '80px' }}>
                            <img 
                              src={img} 
                              alt={`Product ${idx}`} 
                              className="rounded shadow-sm border" 
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                            />
                            <button 
                              type="button"
                              className="btn btn-danger btn-sm rounded-circle position-absolute top-0 end-0 m-n1 p-0 d-flex align-items-center justify-content-center"
                              style={{ width: '20px', height: '20px', marginTop: '-8px', marginRight: '-8px' }}
                              onClick={() => handleRemoveExistingImage(img)}
                              disabled={loading}
                            >
                              <LuX size={12} />
                            </button>
                          </div>
                        ))}

                        {/* New File Previews */}
                        {previews.map((preview, idx) => (
                          <div key={`new-${idx}`} className="position-relative" style={{ width: '80px', height: '80px' }}>
                            <img 
                              src={preview} 
                              alt={`New ${idx}`} 
                              className="rounded shadow-sm border" 
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                            />
                            <button 
                              type="button"
                              className="btn btn-danger btn-sm rounded-circle position-absolute top-0 end-0 m-n1 p-0 d-flex align-items-center justify-content-center"
                              style={{ width: '20px', height: '20px', marginTop: '-8px', marginRight: '-8px' }}
                              onClick={() => removeFile(idx)}
                              disabled={loading}
                            >
                              <LuX size={12} />
                            </button>
                          </div>
                        ))}

                        {/* Upload Button */}
                        {( (data?.images?.length || 0) + selectedFiles.length < 5 ) && (
                          <label 
                            className="d-flex flex-column align-items-center justify-content-center border border-dashed rounded bg-light cursor-pointer text-muted hover-bg-light-blue" 
                            style={{ width: '80px', height: '80px', borderStyle: 'dashed', cursor: 'pointer' }}
                          >
                            <LuPlus size={24} />
                            <span style={{ fontSize: '10px' }}>Upload</span>
                            <input 
                              type="file" 
                              multiple 
                              accept="image/*" 
                              className="d-none" 
                              onChange={handleFileChange}
                              disabled={loading}
                            />
                          </label>
                        )}
                      </div>
                      <small className="text-muted mt-2 d-block">
                        Max 5 images. Formats: JPG, PNG, WEBP.
                      </small>
                    </div>

                    <div className="col-12 mt-4 pt-3 border-top">
                      <div className="d-flex justify-content-end gap-3">
                        <button
                          type="button"
                          className="btn btn-link text-muted text-decoration-none fw-bold"
                          onClick={handleClose}
                          disabled={loading}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary rounded-pill px-5 fw-bold shadow-sm"
                          disabled={loading}
                        >
                          {type === "add" ? `Add Product` : `Save Changes`}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </Spinner>
        </Modal.Body>
      </Modal>
      <ConfirmModal
        show={showRemoveImgModal}
        onHide={() => setShowRemoveImgModal(false)}
        onConfirm={() => {
            dispatch(removeProductImage({ id: data._id, imageUrl: imgToRemove }));
            setShowRemoveImgModal(false);
        }}
        title="Remove Image"
        message="Are you sure you want to remove this product image? This action will immediately update the product listing."
        confirmText="Yes, Remove"
        variant="danger"
        icon={LuTrash2}
      />
    </div>
  );
}
